<template>
  <div>
    <Navigation />
    <div class="top__container section__container">
      <section class="head">
        <div class="">
          <h1 class="header__title center__text">
            SMS pros à tarifs compétitifs Sénégal & international<br/> 
          </h1>
        </div>
      </section>

      <section class="tarrif">
        <div class="terif__info">
          <h1 class="center__text tarif__header">
            NOS FORMULES D'ENVOIS DE SMS
          </h1>
          <p class="center__text tarif__description">
            Consultez nos tarifs et optez pour le paiement mensuel ou ponctuel !
          </p>

          <table class="table first__table sixty__container">
            <thead>
              <tr>
                <th class="transparent"></th>
                <th class="transparent"></th>
                <th>
                  <span class="text">1 à 4.999 </span> <br />
                  <span class="sms">SMS</span>
                </th>
                <th>
                  <span class="text">5.000 à 9.999 </span> <br />
                  <span class="sms">SMS</span>
                </th>
                <th>
                  <span class="text">10.000 à 24.999 </span> <br />
                  <span class="sms">SMS</span>
                </th>
                <th>
                  <span class="text">25.000 à 49.999 </span> <br /><span
                    class="sms"
                    >SMS</span
                  >
                </th>
                <th>
                  <span class="text">50.000 à 99.999</span> <br />
                  <span class="sms">SMS</span>
                </th>
                <th>
                  <span class="text">100.000 à 250.000</span> <br />
                  <span class="sms">SMS</span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="white"></td>
                <td class="lead">
                  <span>TARIF</span> 
                  <span>/SMS</span>
                </td>
                <td class="tri_oran">28,24 F</td>
                <td class="tri_oran">27,58 F</td>
                <td class="tri_oran">26,93 F</td>
                <td class="tri_oran">26,27 F</td>
                <td class="tri_oran">25,58 F</td>
                <td class="tri_oran">24,30 F</td>
              </tr>
              <tr>
                <td style="background:transparent"></td>
                <td></td>
                <td class="tri-blanc-fin"></td>
                <td class="tri-blanc-fin"></td>
                <td class="tri-blanc-fin"></td>
                <td class="tri-blanc-fin"></td>
                <td class="tri-blanc-fin"></td>
                <td class="tri-blanc-fin"></td>
              </tr>
            </tbody>
          </table>

          <table class="table second__table">
            <thead>
              <tr>
                <th>
                  <span class="text">1 à 4.999 </span> <br />
                  <span class="sms">SMS</span>
                </th>
                <th>
                  <span class="text">5.000 à 9.999 </span> <br />
                  <span class="sms">SMS</span>
                </th>
                <th>
                  <span class="text">10.000 à 24.999 </span> <br />
                  <span class="sms">SMS</span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="tri_oran"><span class="price">28,24 F</span></td>
                <td class="tri_oran"><span class="price">27,58 F</span></td>
                <td class="tri_oran"><span class="price">26,93 F</span></td>
              </tr>
              <tr>
                <td class="tri-blanc-fin"></td>
                <td class="tri-blanc-fin"></td>
                <td class="tri-blanc-fin"></td>
              </tr>
            </tbody>
          </table>

          <div class="calculate__price center__text seventy__container">
            <div>
              <h3>Précisez la quantité de SMS désirée</h3>

              <input class="input" v-model="price" @keypress="onlyNumber" />
            </div>

            <div>
              <img class="svg__image" src="/../images/down-arrow.png" alt="" />
              <img
                class="next__arrow"
                src="/../images/next.svg"
                alt=""
                srcset=""
              />
            </div>

            <div>
              <h3>Montant dû à régler (TTC)</h3>
              <div class="tarif__result">
                <span>{{ calculatePrice }} F ({{intervalPrice}} F / SMS)</span>
              </div>
            </div>
          </div>
              <!-- <router-link to="/signup" class="tarif__btn">JE COMMANDE</router-link> -->
              <a href="https://back.servicesms.sn/login" class="tarif__btn" target="_blank">JE COMMANDE</a>

      


        </div>
        <div class="allprices">
  
          <a class="allprices__link" :href="`${publicPath}#`" download="download">         <img class="img allprices__img" src="/../images/download.png" alt="" srcset=""> Télécharger la liste des prix</a>
        </div>

      </section>

      <section class="benifits seventy__container">
        <h1 class="services__title center__text ">
          3 formules d’abonnement désormais disponibles…
      </h1>
      <p class="center__text tarif__description">
        Nous offrons <strong>2 options</strong> pour nos services : les Packs en <strong>pré-paiement</strong>
         et les <strong>Abonnements en illimité</strong>. Explorez nos <strong>3 formules d'abonnement</strong>  <strong> Classique</strong>, 
         <strong>Medium</strong> et <strong>Premium</strong>, qui sont conçues pour s'adapter à tous vos projets. 
         Elles vous offrent des services pré-packagés pour le support client et 
         le suivi technique, <br/>le tout à des tarifs très compétitifs.
      </p>

        <div class="cards">
          <div class="sale">
            <h3 class="price_card title">CLASSIQUE</h3>
            <p class="pri">
              250.000  
            <span class="per">SMS/ans</span>
              
            </p>
              <div class="list">
              <li> <span><CheckIcon class="custom-class pricelist "/> </span>Envois SMS réguliers : solution parfaite </li>
              <li> <span><CheckIcon class="custom-class pricelist "/> </span>Support clients de 9h à 18h, 5j/7</li>
              <li> <span><CheckIcon class="custom-class pricelist "/> </span>Plateforme SaaS SMS en libre accès</li>
              <li> <span><CheckIcon class="custom-class pricelist "/> </span>Un accès à l’API </li>
              <li> <span><CheckIcon class="custom-class pricelist "/> </span>Un envoi de SMS en illimité </li>
              
            

             </div>
          </div>
          <div class="sale">
            <h3 class="title">MEDIUM</h3>
            <p class="pri">
              500.000  
            <span class="per">SMS/ans</span>
              
            </p>
             
             <div class="list">
              <li> <span><CheckIcon class="custom-class pricelist "/> </span>Meilleure solution pour un usage avancé </li>
              <li> <span><CheckIcon class="custom-class pricelist "/> </span>Support clients 24/7, 365j/365</li>
              <li> <span><CheckIcon class="custom-class pricelist "/> </span>Plateforme SaaS SMS en libre accès</li>
              <li> <span><CheckIcon class="custom-class pricelist "/> </span>Un accès à l’API </li>
              <li> <span><CheckIcon class="custom-class pricelist "/> </span>Un envoi de SMS en illimité</li>
            

             </div>
          </div>
          <div class="sale">
            <h3 class="title">PREMIUM</h3>
            <p class="pri">
              1.000.000
            <span class="per">SMS/ans</span>
          
            </p>
             <div class="list">
              <li> <span><CheckIcon class="custom-class pricelist "/> </span>Parfait pour les Grands Comptes </li>
              <li> <span><CheckIcon class="custom-class pricelist "/> </span>Support clients 24/7, 365j/365 </li>
              <li> <span><CheckIcon class="custom-class pricelist "/> </span>Plateforme SaaS SMS en libre accès </li>
              <li> <span><CheckIcon class="custom-class pricelist "/> </span>Un accès à l’API </li>
              <li> <span><CheckIcon class="custom-class pricelist "/> </span>Chargé de projet dédié</li>
              <li> <span><CheckIcon class="custom-class pricelist "/> </span>Un envoi de SMS en illimité</li>
             </div>
          </div>
        </div>
        
          <router-link to="/contact" class="full_btn">CONTACTEZ NOTRE ÉQUIPE
            POUR SOUSCRIRE À NOTRE ABONNEMENT</router-link>

        
        <div class="seventy__container center__text">
          <h1>Ce qui vous attend avec ces nouvelles formules d’abonnement !</h1> 
        </div>
            <div class="cards">
          <div class="card">
            <img class="card__image" src="/../images/icone-tarifs-abonnement.png" alt />
            <div class="card__details center__text">
              <h3 class="card__title">
                Des tarifs ultra-compétitifs
              </h3>
              <p>
                Avec nos récentes options d'abonnement, l'envoi de SMS devient encore
                 plus économique pour les utilisateurs qui envoient fréquemment des 
                 messages en grande quantité, à des tarifs démarrant à seulement <strong>20,47F</strong>
                 toutes taxes comprises.

              </p>
            </div>
          </div>

          <div class="card">
            <img class="card__image" src="/../images/icone-engagement-abonnement.png" alt />
            <div class="card__details center__text">
              <h3 class="card__title">
                Engagement souple, bref
              </h3>
              <p>
                Nos abonnements, avec une durée initiale de 12 mois renouvelable, 
                vous offrent une véritable souplesse. À tout moment, vous avez 
                la possibilité de passer à une formule supérieure afin de vous ajuster
                aux changements dans vos volumes d'envoi.
              </p>
            </div>
          </div>

          <div class="card">
            <img
              class="card__image"
              src="/../images/icone-facture-abonnement.png"
              alt
            />
            <div class="card__details center__text">
              <h3 class="card__title">
                Une facturation post-pay
              </h3>
              <p>
                Votre facturation est calculée à la fin du mois en fonction de
                votre utilisation effective du compte, vous permettant de régler 
                votre facture par virement ou prélèvement bancaire à la fin du mois.
              </p>
            </div>
          </div>
        </div>

        <div class="seventy__container center__text">
          <h1>MOYENS DE PAIEMENT</h1>
          <h2>Une plateforme sécurisée et certifiée avec des règlements fiables !</h2>
          
        </div>
        <div class="partners">
          <img
            class="img__responsive partner__image"
            src="/../images/orange_money.png"
            alt="wari"
          />
          <img
            class="img__responsive partner__image"
            src="/../images/freemoney.png"
            alt=""
          />
          <img
            class="img__responsive partner__image"
            src="/../images/mastercard.png"
            alt=""
          />
          <img
            class="img__responsive partner__image"
            src="/../images/visa.png"
            alt=""
          />
          <img
            class="img__responsive partner__image"
            src="/../images/E money.png"
            alt=""
          />
          <img
            class="img__responsive partner__image"
            src="/../images/wizal.png"
            alt=""
          />
          <img
            class="img__responsive partner__image"
            src="/../images/wave.png"
            alt=""
          />
          <img
            class="img__responsive partner__image"
            src="/../images/moov.png"
            alt=""
          />
          
          
        </div>
        <div class="service__list center__text">
          <h1 class="spacer-2">TOUS NOS PACKS SMS INCLUENT...</h1>
          <div class="grid">
         <img class="img service_img" src="/../images/plateforme-responsive.png"  alt="">
          <ul class="grid__listing">

            <li>
              <img
                class="check__icon"
                src="/../images/icons/gest_contact.png"
                alt=""
              />GESTION DES CONTACTS
            </li>
            <li>
              <img class="check__icon" src="/../images/icons/gest_stop.png" alt="gest" />
              GESTION DES STOPS
            </li>
            <li>
              <img class="check__icon" src="/../images/icons/gest_reponse.png" alt="response" />
              GESTION DES RÉPONSES
            </li>
            <li>
              <img
                class="check__icon"
                src="/../images/icons/temps_reel.png"
                alt="reel"
              />ACCUSÉS EN TEMPS RÉEL
            </li>
            <li>
              <img
                class="check__icon"
                src="/../images/icons/publi_postage.png"
                alt="postage"
              />PUBLIPOSTAGE
            </li>
            <li>
              <img
                class="check__icon"
                src="/../images/icons/programm_send.png"
                alt="program"
              />PROGRAMMATION, BIRTHDAY
            </li>
            <li>
              <img
                class="check__icon"
                src="/../images/icons/statistic_deta.png"
                alt="statastic"
              />STATISTIQUES DÉTAILLÉES
            </li>
            <li>
              <img
                class="check__icon"
                src="/../images/icons/couverture_internat.png"
                alt="couverture"
              />COUVERTURE INTERNATIONALE
            </li>
          </ul>
          </div>
        </div>
      </section>
    </div>
    <section class="premium">
      <h1 class="center__text premium__head">CE QU'OFFRE LA QUALITÉ PREMIUM</h1>
      <ul class="different_tarrif">
        <h4>MESSAGES</h4>
       <li>Personnalisation de l’expéditeur <CheckIcon class="custom-class"/>  </li>
       <li>Message long (+ de 160 caractères) <CheckIcon class="custom-class"/></li>
       <li>Nombre de caractère autorisés <span class="numbers">1224</span></li>
       <li>Publipostage <CheckIcon class="custom-class"/></li>
       <li>Modèle de SMS <CheckIcon class="custom-class"/></li>
       <h4>LIVRAISON</h4>
       <li>Envois programmés <CheckIcon class="custom-class"/></li>
       <li>Livraison instantanée <CheckIcon class="custom-class"/></li>
        <li>Délai réception garanti <CheckIcon class="custom-class"/></li>
        <li>Envoi à l’international (<router-link to="/map" class="link">couverture</router-link>)<CheckIcon class="custom-class"/></li>
        <li>Remise garantie <CheckIcon class="custom-class"/></li>
        <li>Accusés de réception opérateur <CheckIcon class="custom-class"/>	</li>
        <li>Accusés détaillés par numéros <CheckIcon class="custom-class"/></li>
        <li>Horaires d’envois <span class="numbers">24h/24</span></li>
        <h4>CHOIX SUPPLÉMENTAIRES</h4>
        <li>Alertes crédits conso <CheckIcon class="custom-class"/></li>
        <li>Accès via l’API <CheckIcon class="custom-class"/></li>
        <li>Mention STOP SMS <CheckIcon class="custom-class"/> </li>
        <li>Export liste noire <CheckIcon class="custom-class"/> </li>
        <li>SMS réponses <CheckIcon class="custom-class"/></li>
        <li>Espace client sécurisé SSL (https) <CheckIcon class="custom-class"/></li>
        <li>Validité du pack <span class="custom-class"/>À vie ****</li>
        <h4>GESTION DES CONTACTS ASSURÉE</h4>
        <li>Suppression automatique des doublons <CheckIcon class="custom-class"/> 	</li>
        <li>Segmentation intelligente <CheckIcon class="custom-class"/>	</li>
        <li>Liste noire automatique <CheckIcon class="custom-class"/></li>


      </ul>

    </section>

   <Revolution/>

    <Footer />
  </div>
</template>

<script>
import Navigation from "./Navigation";
import Revolution from './Revolution';
import Footer from "./Footer";
import Vue from "vue";
import VueTypeJs from "vue-typed-js";
import { CheckIcon } from "@vue-hero-icons/outline"
Vue.use(VueTypeJs);
export default {
  name: "Tarif",
  data() {
    return {
      price: 1,
      click: true,
      intervalPrice: 28.24,
      publicPath: process.env.BASE_URL

    };
  },
  computed: {
    calculatePrice() {
      //  return (this.price *28.24).toFixed(2);
      if (this.price <= 4999) {
         this.intervalPrice = 28.24;
        return (this.price * 28.24).toFixed(2);
      } else if (this.price == 5000 || this.price <= 9999) {
         this.intervalPrice = 27.58;
        return (this.price * 27.58).toFixed(2);
      } else if (this.price == 10000 || this.price <= 24999) {
            this.intervalPrice = 26.93;
        return (this.price * 26.93).toFixed(2);
      } else if (this.price == 25000 || this.price <= 49999) {
           this.intervalPrice = 26.27;
        return (this.price * 26.27).toFixed(2);
      } else if (this.price == 50.0 || this.price <= 99999) {
            this.intervalPrice =25.58;
        return (this.price * 25.58).toFixed(2);
      } else if (this.price == 100000 || this.price <= 250000) {
         this.intervalPrice = 24.30;
        return (this.price * 24.3).toFixed(2);
      }
    },
  },
  methods: {
    onlyNumber($event) {
      //console.log($event.keyCode); //keyCodes value
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
        // 46 is dot
        $event.preventDefault();
      }
    },
  },
  components: {
    Navigation,
    Footer,
    Revolution,
    CheckIcon
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/base.scss";
.card{
  margin-top:1rem;
}
li{
 
  list-style-type: none;
}

.sale{
    border-radius: 1.75rem;
    box-shadow: 0 12px 24px hsla(210, 61%, 16%, 0.1);
    transition: .4s;
    padding: 2rem 1.5rem 2.5rem;
  
}

.list li{
  display: flex;
  padding-block: .2rem;
  
}

.per{
  font-weight: 400;
  font-size: 0.5em;
  letter-spacing: 2px;
}

.pri{
  font-size: 1.7rem;
  font-weight: 300;
  letter-spacing: -2px;
}
.price_card, .sale{
  
  padding-top: .5rem;
}
.terif__info {
  background-image: url("/../images/arriere-plan-eclairci.jpg");
  background-repeat: no-repeat;

  background-attachment: fixed;
  background-size: cover;

  background-position: bottom;
}
.full_btn{
  border: none;
  padding: 1.3rem;
  display: block;
  margin: 0  0 1rem 0;
  position: relative;
  top: 15px;
  border-radius: 2px;
  text-align: center;
  text-decoration: none;
  background: $color-tertiary;
  color: $color-white;
  font-weight: bold;
  font-size: 0.7rem;
  cursor: pointer;
}
.first__table {
  display: none;
}
.second__table {
  width: 100%;
}

.link{
  text-decoration: none;
  color:#0074d9;
}
table {
  border-collapse: collapse;
  border-spacing: 0;
}

.service__list {
  li {
    list-style-type: none;
    font-weight: bold;
    display: flex;
    align-items: center;
    
  }
}
.check__icon {
  display: inline-block;
  margin-bottom: .4rem;

 
}

.premium__head{
  padding-top:2rem;
}
.custom-class{
  color:$color-tertiary;
  display: inline-block;
  margin-left: auto;
  margin-right: .5rem;
  
}
.different_tarrif{
  li{
    list-style-type: none;
  padding-top: .5rem;
    display: flex;
  }
}
.numbers{
  padding-left: 2rem;
  font-weight: bold;
  margin-left: auto;
  margin-right: .5rem;
}
.price {
  display: block;
  padding-top: 1rem;
}
th {
  text-align: center;
  border-width: 1px;
  background: #0074d9;
  border-style: none;
  padding-top: 0.5rem;
  color: white;
  font-size: 0.7rem;
}

tr {
  font-size: 0.9rem;
}

.partner__image{
  transform: translateY(20px) scale(1.15);
  transform-origin: 50% bottom;
  transition: transform .2s;
  transition: transform 300ms cubic-bezier(0.4, 0, 0.2, 1);
  &:hover {
      transform: translateY(0) scale(1.2);

    transition: ease-out .5s;
  }
}

.transparent {
  width: 1%;
  background-color: rgba(0, 0, 0, 0);
  border: 0px;
}

img {
  max-width: 100%;
  height: auto;
}

td {
  vertical-align: middle;

  font-weight: bold;
  border-style: none;

  padding: 1rem;
  text-align: center;
  border-width: 1px;
}
.svg__image {
  width: 50px;
  padding-top: 1rem;
}

.premium{
  background: hsl(222,41%,95%);
}
.tarif__btn {
  border: none;
  padding: 1.3rem;
  display: block;
  margin: 0 auto;
  position: relative;
  top: 15px;
  border-radius: 2px;
  text-align: center;
  text-decoration: none;
  background: $color-tertiary;
  color: $color-white;
  font-weight: bold;
  font-size: 0.7rem;
  cursor: pointer;

  &:hover {
    background: #5a5cda;
    cursor: pointer;
  }
}
.tri_oran {
  background: url(/../images/new-triangle-orange.gif) center -2px no-repeat !important;
  background-size: cover !important;
  padding-top: 1.5rem;
}

.tri-blanc-fin {
  background: url(/../images/triangle-blanc.png) center -2px no-repeat !important;
  background-size: contain !important;
}

.next__arrow {
  display: none;
}
.tarif__subtext {
  text-align: center;
  font-size: 12px;
  color: #606060;
}

.lead {
  background: white;
}

.sms {
  font-weight: normal;
  display: block;
  padding-top: 0.5rem;
}

.white {
  background: white;
}

.tarif__description {
  padding: 1rem;
}

.input {
  border: none;
  height: 40px;
  border-radius: 4px;
  width: 90%;
}
.input:focus {
  outline: none !important;
  border-color: #0074d9;
  box-shadow: 0 0 10px #719ece;
}

.tarif__result {
  background: #0074d9;
  color: white;
  padding: 1.5rem;
  font-weight: bold;
}
.allprices__img{
  margin-top:.5rem;
}
.allprices{
  display: flex;
  margin-top: 1.5rem;
  

  &__link{
    display: inline-block;
    text-decoration: none;
    color:$color-black;
    font-weight: bold;
    padding-left: .5rem;
  }
}

@media (min-width: 40rem) {

  .next__arrow {
    display: block;
    width: 50px;
    margin: 4rem auto;
  }
  .svg__image {
    display: none;
  }
  .second__table {
    display: none;
  }
  .first__table {
    display: block;
  }
}

.center__text {
  text-align: center;
}

.head {
  background: $color-grey;
  
  border-radius: 0.25rem;
  box-shadow: 0 20px 40px -14px rgba(0, 0, 0, 0.25);
 
}

.partner__image {
  display: block;
  margin: 1rem auto;
  border-radius: 0.25rem;
  
}

.sub__paragraph {
  font-size: 1.2rem;
  
  padding:0 1rem;
}

::placeholder {
  text-align: center;
}
.tarif__price {
  background: $color-tertiary;
  color: $color-white;
  padding: 0.5rem;
  font-size: 2rem;
}

.first__word {
  font-weight: bolder;
  background: $color-tertiary;
  color: $color-white;
}
.card {
  background: $color-grey;
  border-radius: 0.25rem;
  box-shadow: 0 20px 40px -14px rgba(0, 0, 0, 0.25);
}
@media (min-width: 64rem) {
  .center__head {
    width: 50%;
    margin: 0 auto;
  }
    .header__title{
    margin-top: -7.2rem;
  }
  .tarif__header {
    padding-top: 2rem;
  }
  .partners {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    gap: 2rem;
  }
  .grid__listing {
    width: 60%;
    margin: 0 auto;

  }
  .service_img{
    
    margin-top: 2rem;
  }
  .service__list{
    li{
      margin-top: 1rem;
      width: 18rem;
      padding-right: 4rem;
    }
  }
  .tarif__details {
    width: 50%;
    margin: 0 auto;
  }

  .tarif__btn {
       width: 11rem;
    padding: 1rem;
    top: 25px;
    text-align: center;
    font-size: 1.2rem;
    text-decoration: none;
  }
  .calculate__price {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
  }
.different_tarrif{
  width: 50%;
  margin: 0 auto;
}
.grid{
  display:grid;
  grid-template-columns: 1fr 1fr;
}
}
</style>
